export const INTERNAL_STATUS_ACTIVE = 'Active';
export const INTERNAL_STATUS_PENDING = 'Pending';

export const RECORD_TYPE_APPOINTMENT = 'appointment';
export const RECORD_TYPE_DRUG = 'drug';
export const RECORD_TYPE_PROCEDURE = 'procedure';
export const RECORD_TYPE_ENROLMENT = 'enrolment';
export const RECORD_TYPE_OPTIONS = [
  { value: RECORD_TYPE_APPOINTMENT, label: 'Appointments' },
  { value: RECORD_TYPE_DRUG, label: 'Medications' },
  { value: RECORD_TYPE_PROCEDURE, label: 'Procedures' },
  { value: RECORD_TYPE_ENROLMENT, label: 'Patient Enrolments' },
];

// Clinical Event Type Filter for Review Queue
export const CLINICAL_EVENT_TYPE_APPOINTMENT = 'Visit';
export const CLINICAL_EVENT_TYPE_PROCEDURE = 'Procedure';
export const CLINICAL_EVENT_TYPE_ENROLMENT = 'Enrolment';

export const getClinicalEventTypeOptions = ({ t }) => [
  { value: CLINICAL_EVENT_TYPE_APPOINTMENT, label: t('appointments') },
  { value: CLINICAL_EVENT_TYPE_PROCEDURE, label: t('procedures') },
  { value: CLINICAL_EVENT_TYPE_ENROLMENT, label: t('enrolments') },
];

export const APPOINTMENT_STATUS_OPTION_ALL = 'all';
export const APPOINTMENT_STATUS_OPTION_BOOKED = 'booked';
export const APPOINTMENT_STATUS_OPTION_COMPLETED = 'completed';
export const APPOINTMENT_STATUS_OPTION_NO_SHOW = 'no show'; // Backend uses 'no show' with space
export const APPOINTMENT_STATUS_OPTION_CANCELED = 'cancelled'; // Backend uses British spelling 'cancelled'

export const CLINICIAN_OPTION_ALL = 'all';
export const CLINICIAN_OPTION_SARAH_JOHNSON = 'Dr. Sarah Johnson';
export const CLINICIAN_OPTION_MICHAEL_BROWN = 'Dr. Michael Brown';
export const CLINICIAN_OPTION_LISA_WILLIAMS = 'Dr. Lisa Williams';
export const CLINICIAN_OPTION_JAMES_WILSON = 'Dr. James Wilson';
export const CLINICIAN_OPTION_EMILY_DAVIS = 'Dr. Emily Davis';
export const CLINICIAN_OPTION_ROBERT_MILLER = 'Dr. Robert Miller';

export const CLINICIAN_OPTIONS = [
  { label: 'All Clinicians', value: CLINICIAN_OPTION_ALL },
  { label: 'Dr. Sarah Johnson', value: CLINICIAN_OPTION_SARAH_JOHNSON },
  { label: 'Dr. Michael Brown', value: CLINICIAN_OPTION_MICHAEL_BROWN },
  { label: 'Dr. Lisa Williams', value: CLINICIAN_OPTION_LISA_WILLIAMS },
  { label: 'Dr. James Wilson', value: CLINICIAN_OPTION_JAMES_WILSON },
  { label: 'Dr. Emily Davis', value: CLINICIAN_OPTION_EMILY_DAVIS },
  { label: 'Dr. Robert Miller', value: CLINICIAN_OPTION_ROBERT_MILLER },
];

// Medication

export const MEDICATION_STATUS_OPTION_ALL = 'all';
export const MEDICATION_STATUS_OPTION_PRESCRIBED = 'prescribed';
export const MEDICATION_STATUS_OPTION_DISPENSED = 'dispensed';
export const MEDICATION_STATUS_OPTION_ADMINISTERED = 'administered';
export const MEDICATION_STATUS_OPTION_CANCELED = 'canceled';

export const getMedicationStatusType = (priority) => {
  switch (priority) {
    case MEDICATION_STATUS_OPTION_PRESCRIBED:
      return 'info';
    case MEDICATION_STATUS_OPTION_DISPENSED:
      return 'warning';
    case MEDICATION_STATUS_OPTION_ADMINISTERED:
      return 'success';
    case MEDICATION_STATUS_OPTION_CANCELED:
      return 'danger';
    default:
      return null;
  }
};

export const getMedicationStatusLabel = ({ status, t }) => {
  switch (status) {
    case MEDICATION_STATUS_OPTION_ALL:
      return t('all');
    case MEDICATION_STATUS_OPTION_PRESCRIBED:
      return t('states:prescribed');
    case MEDICATION_STATUS_OPTION_DISPENSED:
      return t('states:dispensed');
    case MEDICATION_STATUS_OPTION_ADMINISTERED:
      return t('states:administered');
    case MEDICATION_STATUS_OPTION_CANCELED:
      return t('states:canceled');
    default:
      return null;
  }
};

export const getMedicationStatusOptions = ({ t }) => [
  {
    label: getMedicationStatusLabel({
      status: MEDICATION_STATUS_OPTION_ALL,
      t,
    }),
    value: MEDICATION_STATUS_OPTION_ALL,
  },
  {
    label: getMedicationStatusLabel({
      status: MEDICATION_STATUS_OPTION_PRESCRIBED,
      t,
    }),
    value: MEDICATION_STATUS_OPTION_PRESCRIBED,
  },
  {
    label: getMedicationStatusLabel({
      status: MEDICATION_STATUS_OPTION_DISPENSED,
      t,
    }),
    value: MEDICATION_STATUS_OPTION_DISPENSED,
  },
  {
    label: getMedicationStatusLabel({
      status: MEDICATION_STATUS_OPTION_ADMINISTERED,
      t,
    }),
    value: MEDICATION_STATUS_OPTION_ADMINISTERED,
  },
  {
    label: getMedicationStatusLabel({
      status: MEDICATION_STATUS_OPTION_CANCELED,
      t,
    }),
    value: MEDICATION_STATUS_OPTION_CANCELED,
  },
];

// Procedure

export const PROCEDURE_STATUS_OPTION_ALL = 'all';
export const PROCEDURE_STATUS_OPTION_BOOKED = 'booked';
export const PROCEDURE_STATUS_OPTION_COMPLETED = 'completed';
export const PROCEDURE_STATUS_OPTION_NO_SHOW = 'no-show';
export const PROCEDURE_STATUS_OPTION_CANCELED = 'canceled';
export const PROCEDURE_STATUS_OPTION_ABORTED = 'aborted';

export const getProcedureStatusLabel = ({ status, t }) => {
  switch (status) {
    case PROCEDURE_STATUS_OPTION_ALL:
      return t('all');
    case PROCEDURE_STATUS_OPTION_BOOKED:
      return t('states:booked');
    case PROCEDURE_STATUS_OPTION_COMPLETED:
      return t('states:completed');
    case PROCEDURE_STATUS_OPTION_CANCELED:
      return t('states:canceled');
    case PROCEDURE_STATUS_OPTION_NO_SHOW:
      return t('states:noShow');
    case PROCEDURE_STATUS_OPTION_ABORTED:
      return t('states:aborted');
    default:
      return null;
  }
};

export const getProcedureStatusOptions = ({ t }) => [
  {
    label: getProcedureStatusLabel({
      status: PROCEDURE_STATUS_OPTION_ALL,
      t,
    }),
    value: PROCEDURE_STATUS_OPTION_ALL,
  },
  {
    label: getProcedureStatusLabel({
      status: PROCEDURE_STATUS_OPTION_BOOKED,
      t,
    }),
    value: PROCEDURE_STATUS_OPTION_BOOKED,
  },
  {
    label: getProcedureStatusLabel({
      status: PROCEDURE_STATUS_OPTION_COMPLETED,
      t,
    }),
    value: PROCEDURE_STATUS_OPTION_COMPLETED,
  },
  {
    label: getProcedureStatusLabel({
      status: PROCEDURE_STATUS_OPTION_CANCELED,
      t,
    }),
    value: PROCEDURE_STATUS_OPTION_CANCELED,
  },
  {
    label: getProcedureStatusLabel({
      status: PROCEDURE_STATUS_OPTION_NO_SHOW,
      t,
    }),
    value: PROCEDURE_STATUS_OPTION_NO_SHOW,
  },
  {
    label: getProcedureStatusLabel({
      status: PROCEDURE_STATUS_OPTION_ABORTED,
      t,
    }),
    value: PROCEDURE_STATUS_OPTION_ABORTED,
  },
];

export const getProcedureStatusType = (priority) => {
  switch (priority) {
    case PROCEDURE_STATUS_OPTION_BOOKED:
      return 'info';
    case PROCEDURE_STATUS_OPTION_COMPLETED:
      return 'success';
    case PROCEDURE_STATUS_OPTION_NO_SHOW:
    case PROCEDURE_STATUS_OPTION_CANCELED:
    case PROCEDURE_STATUS_OPTION_ABORTED:
      return 'danger';
    default:
      return null;
  }
};

// Enrolment

export const ENROLMENT_STATUS_OPTION_ALL = 'all';
export const ENROLMENT_STATUS_OPTION_ACTIVE = 'active';
export const ENROLMENT_STATUS_OPTION_INACTIVE = 'inactive';
export const ENROLMENT_STATUS_OPTION_DECEASED = 'deceased';

export const getEnrolmentStatusLabel = ({ status, t }) => {
  switch (status) {
    case ENROLMENT_STATUS_OPTION_ALL:
      return t('all');
    case ENROLMENT_STATUS_OPTION_ACTIVE:
      return t('states:active');
    case ENROLMENT_STATUS_OPTION_INACTIVE:
      return t('states:inactive');
    case ENROLMENT_STATUS_OPTION_DECEASED:
      return t('states:deceased');
    default:
      return null;
  }
};

export const getEnrolmentStatusOptions = ({ t }) => [
  {
    label: getEnrolmentStatusLabel({
      status: ENROLMENT_STATUS_OPTION_ALL,
      t,
    }),
    value: ENROLMENT_STATUS_OPTION_ALL,
  },
  {
    label: getEnrolmentStatusLabel({
      status: ENROLMENT_STATUS_OPTION_ACTIVE,
      t,
    }),
    value: ENROLMENT_STATUS_OPTION_ACTIVE,
  },
  {
    label: getEnrolmentStatusLabel({
      status: ENROLMENT_STATUS_OPTION_INACTIVE,
      t,
    }),
    value: ENROLMENT_STATUS_OPTION_INACTIVE,
  },
  {
    label: getEnrolmentStatusLabel({
      status: ENROLMENT_STATUS_OPTION_DECEASED,
      t,
    }),
    value: ENROLMENT_STATUS_OPTION_DECEASED,
  },
];

// Appointment

export const getAppointmentStatusType = (priority) => {
  switch (priority) {
    case APPOINTMENT_STATUS_OPTION_BOOKED:
      return 'info';
    case APPOINTMENT_STATUS_OPTION_COMPLETED:
      return 'success';
    case APPOINTMENT_STATUS_OPTION_CANCELED:
    case APPOINTMENT_STATUS_OPTION_NO_SHOW:
      return 'danger';
    default:
      return null;
  }
};

export const getAppointmentStatusLabel = ({ status, t }) => {
  switch (status) {
    case APPOINTMENT_STATUS_OPTION_ALL:
      return t('all');
    case APPOINTMENT_STATUS_OPTION_BOOKED:
      return t('states:booked');
    case APPOINTMENT_STATUS_OPTION_COMPLETED:
      return t('states:completed');
    case APPOINTMENT_STATUS_OPTION_CANCELED:
      return t('states:canceled');
    case APPOINTMENT_STATUS_OPTION_NO_SHOW:
      return t('states:noShow');
    default:
      return null;
  }
};

export const getAppointmentStatusOptions = ({ t }) => [
  {
    label: getAppointmentStatusLabel({
      status: APPOINTMENT_STATUS_OPTION_ALL,
      t,
    }),
    value: APPOINTMENT_STATUS_OPTION_ALL,
  },
  {
    label: getAppointmentStatusLabel({
      status: APPOINTMENT_STATUS_OPTION_BOOKED,
      t,
    }),
    value: APPOINTMENT_STATUS_OPTION_BOOKED,
  },
  {
    label: getAppointmentStatusLabel({
      status: APPOINTMENT_STATUS_OPTION_COMPLETED,
      t,
    }),
    value: APPOINTMENT_STATUS_OPTION_COMPLETED,
  },
  {
    label: getAppointmentStatusLabel({
      status: APPOINTMENT_STATUS_OPTION_NO_SHOW,
      t,
    }),
    value: APPOINTMENT_STATUS_OPTION_NO_SHOW,
  },
  {
    label: getAppointmentStatusLabel({
      status: APPOINTMENT_STATUS_OPTION_CANCELED,
      t,
    }),
    value: APPOINTMENT_STATUS_OPTION_CANCELED,
  },
];

// Record

export const getRecordStatusLabel = ({ status, t }) => {
  switch (status) {
    case APPOINTMENT_STATUS_OPTION_ALL:
    case MEDICATION_STATUS_OPTION_ALL:
      return t('all');
    case APPOINTMENT_STATUS_OPTION_CANCELED:
    case MEDICATION_STATUS_OPTION_CANCELED:
      return t('states:canceled');

    case APPOINTMENT_STATUS_OPTION_BOOKED:
      return t('states:booked');
    case APPOINTMENT_STATUS_OPTION_COMPLETED:
      return t('states:completed');
    case APPOINTMENT_STATUS_OPTION_NO_SHOW:
      return t('states:noShow');

    case MEDICATION_STATUS_OPTION_PRESCRIBED:
      return t('states:prescribed');
    case MEDICATION_STATUS_OPTION_DISPENSED:
      return t('states:dispensed');
    case MEDICATION_STATUS_OPTION_ADMINISTERED:
      return t('states:administered');

    default:
      return null;
  }
};

export const getRecordStatusType = (priority) => {
  switch (priority) {
    case APPOINTMENT_STATUS_OPTION_BOOKED:
    case MEDICATION_STATUS_OPTION_PRESCRIBED:
    case PROCEDURE_STATUS_OPTION_BOOKED:
      return 'info';
    case MEDICATION_STATUS_OPTION_DISPENSED:
      return 'waring';
    case APPOINTMENT_STATUS_OPTION_COMPLETED:
    case MEDICATION_STATUS_OPTION_ADMINISTERED:
    case PROCEDURE_STATUS_OPTION_COMPLETED:
    case ENROLMENT_STATUS_OPTION_ACTIVE:
      return 'success';
    case APPOINTMENT_STATUS_OPTION_CANCELED:
    case APPOINTMENT_STATUS_OPTION_NO_SHOW:
    case MEDICATION_STATUS_OPTION_CANCELED:
    case PROCEDURE_STATUS_OPTION_NO_SHOW:
    case PROCEDURE_STATUS_OPTION_CANCELED:
    case PROCEDURE_STATUS_OPTION_ABORTED:
    case ENROLMENT_STATUS_OPTION_INACTIVE:
    case ENROLMENT_STATUS_OPTION_DECEASED:
      return 'danger';
    default:
      return null;
  }
};

export const getRecordBorderColor = (status) => {
  switch (status) {
    case APPOINTMENT_STATUS_OPTION_BOOKED:
    case MEDICATION_STATUS_OPTION_PRESCRIBED:
      return 'border-info';
    case MEDICATION_STATUS_OPTION_DISPENSED:
      return 'border-warning';
    case APPOINTMENT_STATUS_OPTION_COMPLETED:
    case MEDICATION_STATUS_OPTION_ADMINISTERED:
      return 'border-success';
    case APPOINTMENT_STATUS_OPTION_CANCELED:
    case APPOINTMENT_STATUS_OPTION_NO_SHOW:
    case MEDICATION_STATUS_OPTION_CANCELED:
      return 'border-danger';
    default:
      return 'border-neutral';
  }
};

export const getRecordColor = (status) => {
  switch (status) {
    case APPOINTMENT_STATUS_OPTION_BOOKED:
    case MEDICATION_STATUS_OPTION_PRESCRIBED:
      return 'bg-info border-info text-on-info';
    case MEDICATION_STATUS_OPTION_DISPENSED:
      return 'bg-warning border-warning text-on-warning';
    case APPOINTMENT_STATUS_OPTION_COMPLETED:
    case MEDICATION_STATUS_OPTION_ADMINISTERED:
      return 'bg-success border-success text-on-success';
    case APPOINTMENT_STATUS_OPTION_CANCELED:
    case APPOINTMENT_STATUS_OPTION_NO_SHOW:
    case MEDICATION_STATUS_OPTION_CANCELED:
      return 'bg-danger border-danger text-on-danger';
    default:
      return 'bg-neutral border-neutral text-on-neutral';
  }
};

export const getRecordHoverColor = (status) => {
  switch (status) {
    case APPOINTMENT_STATUS_OPTION_BOOKED:
    case MEDICATION_STATUS_OPTION_PRESCRIBED:
      return 'group-hover:border-info-muted';
    case MEDICATION_STATUS_OPTION_DISPENSED:
      return 'group-hover:border-warning-muted';
    case APPOINTMENT_STATUS_OPTION_COMPLETED:
    case MEDICATION_STATUS_OPTION_ADMINISTERED:
      return 'group-hover:border-success-muted';
    case APPOINTMENT_STATUS_OPTION_CANCELED:
    case APPOINTMENT_STATUS_OPTION_NO_SHOW:
    case MEDICATION_STATUS_OPTION_CANCELED:
      return 'group-hover:border-danger-muted';
    default:
      return 'group-hover:border-neutral-muted';
  }
};

export const getRecordRingColor = (status) => {
  switch (status) {
    case APPOINTMENT_STATUS_OPTION_BOOKED:
    case MEDICATION_STATUS_OPTION_PRESCRIBED:
      return 'ring-info';
    case MEDICATION_STATUS_OPTION_DISPENSED:
      return 'bg-warning border-warning text-on-warning';
    case APPOINTMENT_STATUS_OPTION_COMPLETED:
    case MEDICATION_STATUS_OPTION_ADMINISTERED:
      return 'ring-success';
    case APPOINTMENT_STATUS_OPTION_CANCELED:
    case APPOINTMENT_STATUS_OPTION_NO_SHOW:
    case MEDICATION_STATUS_OPTION_CANCELED:
      return 'ring-danger-500';
    default:
      return 'ring-neutral';
  }
};
